var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feature",class:{
    'feature--dark': _vm.theme === 'dark'
  }},[_c('div',{staticClass:"feature__icon"},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.title,"loading":"lazy"}})]),_vm._v(" "),_c('div',{staticClass:"feature__content"},[_c('span',{staticClass:"feature__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"feature__description",domProps:{"innerHTML":_vm._s(_vm.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }